module.exports = __webpack_public_path__ + "static/media/ax.f8c4019f.svg";